import { createContext, useCallback, useEffect, useRef, useState } from 'react';
import { WithChildren } from '../helpers';
import { FC } from 'react';
import { generateToken } from '../helpers/commonFunctions';
import Auth from 'opensooq-sso';
import { ProfileInterface } from '../interfaces/ProfileInterface';
import { resetSocket } from '../modules/socket-v5/providers/socketService';

interface AuthContextValue {
  isLoggedIn: boolean;
  regenerateToken: () => Promise<string>;
  userIdentity: ProfileInterface | undefined;
  updateProfile: (newProfile: Partial<ProfileInterface>) => void;
  triggerImagePreview: (imageUrl: string) => void;
}

const authInitState: AuthContextValue = {
  isLoggedIn: false,
  regenerateToken: () =>
    new Promise<string>(() => {
      return '';
    }),
  userIdentity: undefined,
  updateProfile: () => {},
  triggerImagePreview: () => {},
};
export const AuthContext = createContext(authInitState);
const AuthProvider: FC<WithChildren> = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userIdentity, setUserIdentity] = useState<ProfileInterface | undefined>(undefined);
  const previousUserIdRef = useRef<number | string | undefined>(undefined);

  const getUserIdentity = async () => {
    const userInfo = await Auth.getInstance().getIdentity();
    if (previousUserIdRef.current && userInfo?.id && previousUserIdRef.current !== userInfo.id) {
      resetSocket();
    }
    previousUserIdRef.current = userInfo?.id;
    console.log('userImage', userInfo);

    setUserIdentity(userInfo);
  };
  const triggerImagePreview = useCallback((imageUrl: string) => {
    window.dispatchEvent(new CustomEvent('imagePreview', { detail: imageUrl }));
  }, []);

  const updateProfile = useCallback((newProfile: Partial<ProfileInterface>) => {
    setUserIdentity((prevProfile) => {
      const nextProfile = prevProfile
        ? { ...prevProfile, ...newProfile }
        : (newProfile as ProfileInterface);
      window.dispatchEvent(new CustomEvent('profileUpdated', { detail: nextProfile }));
      return nextProfile;
    });
  }, []);

  useEffect(() => {
    getUserIdentity();
  }, []);

  const regenerateToken = useCallback(() => {
    return generateToken().then(async (token) => {
      if (token) {
        setIsLoggedIn(true);

        const userInfo = await Auth.getInstance().getIdentity();
        if (
          previousUserIdRef.current &&
          userInfo?.id &&
          previousUserIdRef.current !== userInfo.id
        ) {
          resetSocket();
        }
        previousUserIdRef.current = userInfo?.id;
        setUserIdentity(userInfo);
      }
      return token;
    });
  }, []);

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        regenerateToken,
        userIdentity,
        updateProfile,
        triggerImagePreview,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
export default AuthProvider;
